module.exports = __webpack_public_path__ + "img/1.a0ba4415.png";